<template>
  <div
    class="py-2 text-white section lg:py-4"
    id="quiz-links"
    v-if="content_ids.length"
  >
    <div class="container">
      <div class="container__inner px-1.5">
        <div>
          <ul class="flex flex-wrap items-center p-0 py-2 m-0 list-none">
            <li class="pb-1 pr-1.5" v-for="content in contents">
              <a type="button" class="bt" :href="content.url">
                <span>{{ content.label }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { ref } from "vue";

const props = defineProps({
  content_ids: {
    type: Array,
    required: true,
  },
});
const contents = ref([]);
const fetchContents = () => {
  const response = fetch(
    `${
      import.meta.env.VITE_QUIZ_API_ENDPOINT
    }/contents/?ids=${props.content_ids.join(",")}`
  )
    .then((response) => response.json())
    .then((data) => {
      contents.value = data;
    });
};
fetchContents();
</script>
